import { memo } from "react";
import { Handle, Position } from "@xyflow/react";
import { CATEGORY_COLORS, BELT_COLORS } from "@/lib/constants";
import { getThumbnail } from "@/lib/video";
import { Play, X } from "lucide-react";

function TechniqueNode({ data }) {
  const t = data.technique || {};
  return (
    <div data-testid={`flow-node-${t.id}`} className="group relative w-56">
      {/* Connection dots on all four sides (not clipped) */}
      <Handle type="source" id="top" position={Position.Top} style={{ zIndex: 20 }} />
      <Handle type="source" id="right" position={Position.Right} style={{ zIndex: 20 }} />
      <Handle type="source" id="bottom" position={Position.Bottom} style={{ zIndex: 20 }} />
      <Handle type="source" id="left" position={Position.Left} style={{ zIndex: 20 }} />

      {/* Visual card (clipped corners) */}
      <div onClick={() => data.onOpen?.(t)}
        className="cursor-pointer rounded-xl bg-zinc-900 border border-zinc-700 group-hover:border-red-500 group-hover:shadow-[0_0_15px_rgba(230,57,70,0.4)] transition-all duration-300 overflow-hidden">
        {data.onRemove && (
          <button data-testid={`node-remove-${t.id}`} onClick={(e) => { e.stopPropagation(); data.onRemove(); }}
            className="absolute top-1.5 right-1.5 z-30 h-6 w-6 rounded-full bg-black/70 hover:bg-destructive flex items-center justify-center opacity-0 group-hover:opacity-100 max-md:opacity-100 transition-opacity">
            <X className="h-3.5 w-3.5 text-white" />
          </button>
        )}
        <div className="relative h-24 bg-black">
          <img src={getThumbnail(t)} alt="" className="absolute inset-0 w-full h-full object-cover opacity-40" />
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="h-8 w-8 rounded-full bg-primary/90 flex items-center justify-center">
              <Play className="h-4 w-4 text-white fill-white ml-0.5" />
            </div>
          </div>
          {t.belt_level && <span className="absolute top-1.5 left-1.5 h-3 w-3 rounded-full border border-white/40" style={{ background: BELT_COLORS[t.belt_level] }} />}
        </div>
        <div className="p-3">
          {t.category && <span className="text-[9px] font-semibold uppercase tracking-wide px-1.5 py-0.5 rounded" style={{ background: `${CATEGORY_COLORS[t.category]}22`, color: CATEGORY_COLORS[t.category] }}>{t.category}</span>}
          <p className="font-heading font-semibold text-sm mt-1.5 text-white leading-tight line-clamp-2">{t.name}</p>
          {t.position && <p className="text-[11px] text-zinc-400 mt-0.5">{t.position}</p>}
        </div>
      </div>
    </div>
  );
}

export default memo(TechniqueNode);
